import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCard = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M1.75 8.75v5.5a2 2 0 0 0 2 2h12.5a2 2 0 0 0 2-2v-5.5m-16.5 0v-3a2 2 0 0 1 2-2h12.5a2 2 0 0 1 2 2v3m-16.5 0h16.5m-13.5 4h3.5"
	})]
});
const ForwardRef = forwardRef(SvgCard);
export { ForwardRef as ReactComponent };
